import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Typography, Row, Col, Table } from "antd";
// css
import "assets/styles/overview.scss";
import "assets/styles/statistic.scss";
import OverviewCardByDate from "./OverviewCardByDate";
import { merchantPermission } from "../../requests/auth";

const { Title } = Typography;

const PayinOverview = () => {
  const authUser = useSelector((state) => state.auth.authUser);
  const [permission, setPermission] = useState({});
  
    const handlePermission = async () => {
      try {
        const res = await merchantPermission();
        if (res.data.status === '1') {
          setPermission(res.data.data || {});
        } else {
          setPermission({});
        }
      } catch (err) {
        console.error('Error fetching permissions:', err);
      }
    };
  
    useEffect(() => {
      handlePermission();
    }, []);
  

  return (
    <div className="overview-content border-red">
      <div className="overview-main">
        {permission.dashboard === 'true' && (
        <OverviewCardByDate />
        )}
      </div>
    </div>
  );
};

export default PayinOverview;
